import type { FragmentOf } from '@/utilities/gql';
import type { PopulatedStateBaseProps } from './PopulatedState';
import { PopulatedState } from './PopulatedState';
import {
  type NarrativeCardSyntheticProps,
  // NarrativeCardSynthetic,
} from './components/NarrativeCardSynthetic';
import type { NARRATIVE_CARD_ISOMORPHIC_FRAGMENT } from '../../fragments';

type Props = (
  | PopulatedStateBaseProps
  | Omit<NarrativeCardSyntheticProps, 'narrative'>
) & {
  narrative: FragmentOf<typeof NARRATIVE_CARD_ISOMORPHIC_FRAGMENT>;
};

export const NarrativeCardIsomorphic = (props: Props) => {
  const { narrative } = props;

  // TODO: See if NarrativeCardSynthetic is needed still - style or remove
  if (['dcf', 'analysts'].includes(narrative.valuation.type)) return;
  // return <NarrativeCardSynthetic {...props} />;

  return <PopulatedState {...props} />;
};
